export default "__VITE_ASSET__VJ7XrNbB__"